/**
 * Bandeau de consentement — pilotage (05/10/2026).
 *
 * Ce fichier ne connaît AUCUNE régie. Il recueille la réponse, l'enregistre (cookie `on_accord`, six mois) et l'annonce par un
 * événement DOM `on:accord` (true = accepté). Le relais vers Shopify écoute cet événement (layout/theme.liquid).
 *
 * Une exception, Shopify : il garde SA mémoire du choix (liée à sa session, plus longue que les six mois de `on_accord`). Quand notre
 * cookie a expiré ou a été effacé (« Gérer mes cookies »), un « oui » resté chez Shopify continuerait d'autoriser ses cookies de
 * mesure pendant que le bandeau repose la question : on le lui fait oublier AVANT toute nouvelle réponse.
 *
 * Hauteur du bandeau publiée dans --on-cnb-h (sur <html>) : la barre d'onglets et la barre d'achat se posent au-dessus de lui.
 */
(function () {
	'use strict';

	var C = window.ON_ACCORD || {};
	if (!C.cookie) { return; }

	var bandeau = null;
	var oubli = Promise.resolve();   // remise à zéro chez Shopify en cours : une réponse attend qu'elle soit faite

	/**
	 * Fait oublier à Shopify un « oui » qui n'a plus de réponse en face chez nous. Ne crée aucune décision : un consentement vide reste
	 * vide. Ne bloque jamais plus de 5 s (API absente, chargement raté : on continue comme avant).
	 */
	function oublieShopify() {
		return new Promise(function (fini) {
			var S = window.Shopify;
			function agit() {
				var cp = S && S.customerPrivacy;
				if (!cp || !cp.setTrackingConsent || !cp.currentVisitorConsent) { return fini(); }
				var a = cp.currentVisitorConsent() || {};
				if ('yes' !== a.analytics && 'yes' !== a.marketing && 'yes' !== a.preferences && 'yes' !== a.sale_of_data) { return fini(); }
				cp.setTrackingConsent({ analytics: false, marketing: false, preferences: false, sale_of_data: false }, function () { fini(); });
			}
			if (S && S.customerPrivacy) { agit(); }
			else if (S && S.loadFeatures) { S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) { if (err) { fini(); } else { agit(); } }); }
			else { fini(); }
			setTimeout(fini, 5000);
		});
	}

	function ecritCookie(valeur, duree) {
		document.cookie = C.cookie + '=' + valeur + ';path=/;max-age=' + duree + ';samesite=lax' + (location.protocol === 'https:' ? ';secure' : '');
	}

	function annonce(accepte) {
		document.dispatchEvent(new CustomEvent('on:accord', { detail: accepte }));
	}

	/**
	 * --on-cnb-h = hauteur RENDUE du bandeau (0 s'il est caché, retiré, ou masqué sous un panneau ouvert).
	 * --on-cnb-h1 = hauteur de son 1er écran, relevée seulement quand il est affiché et jamais remise à 0 : le héros de l'accueil réserve
	 * la place du bandeau à la 1re visite (on-retouches.css) et ne doit ni rétrécir à l'ouverture d'« En savoir plus » ni regrandir à la
	 * réponse ; il ne suit la hauteur réelle que si elle dépasse l'estimation faite avant le premier rendu (texte agrandi).
	 */
	function publieHauteur() {
		var h = bandeau && bandeau.isConnected && !bandeau.hidden ? bandeau.getBoundingClientRect().height : 0;
		var st = document.documentElement.style;
		st.setProperty('--on-cnb-h', Math.round(h) + 'px');
		var un = h ? bandeau.querySelector('[data-cnb-ecran="1"]') : null;
		if (un && !un.hidden) { st.setProperty('--on-cnb-h1', Math.ceil(h) + 'px'); }
	}

	function repond(valeur) {
		ecritCookie(valeur, C.duree);
		if (bandeau) { bandeau.remove(); bandeau = null; }
		publieHauteur();
		// L'annonce n'attend aucun appel réseau, sauf la remise à zéro chez Shopify si elle est en cours : sinon elle effacerait un
		// « Accepter » donné pendant qu'elle se faisait.
		oubli.then(function () { annonce('oui' === valeur); });
	}

	function montre() {
		bandeau = document.querySelector('[data-cnb]');
		if (!bandeau) { return; }
		bandeau.hidden = false;
		if ('ResizeObserver' in window) { new ResizeObserver(publieHauteur).observe(bandeau); }
		publieHauteur();

		bandeau.addEventListener('click', function (e) {
			var b = e.target.closest('[data-cnb]');
			if (!b || b === bandeau) { return; }
			var quoi = b.getAttribute('data-cnb');
			if ('plus' === quoi) {
				e.preventDefault();
				var un = bandeau.querySelector('[data-cnb-ecran="1"]'), deux = bandeau.querySelector('[data-cnb-ecran="2"]');
				if (un && deux) { un.hidden = true; deux.hidden = false; try { deux.focus({ preventScroll: true }); } catch (x) { deux.focus(); } }
				return;
			}
			if ('oui' === quoi || 'non' === quoi) { e.preventDefault(); repond(quoi); }
		});
	}

	/**
	 * « Gérer mes cookies » (pied de page) : efface notre réponse puis recharge la page. Le bandeau revient (le petit script qui le
	 * retire ne trouve plus de réponse) et demarre() fait d'abord oublier à Shopify un « oui » éventuel : revenir sur son choix est
	 * aussi simple que de le donner.
	 */
	document.addEventListener('click', function (e) {
		var g = e.target.closest && e.target.closest('[data-cnb-gerer]');
		if (!g) { return; }
		e.preventDefault();
		ecritCookie('', 0);
		location.reload();
	});

	function demarre() {
		if (C.repondu) {
			// Réponse déjà donnée : réannoncée à chaque page, sinon un module chargé après ne saurait jamais ce qu'il a le droit de faire.
			annonce(!!C.accord);
			return;
		}
		// Aucune réponse en vigueur chez nous (première visite, ou `on_accord` expiré ou effacé) : Shopify ne doit pas en garder une.
		oubli = oublieShopify();
		montre();
	}

	if ('loading' === document.readyState) { document.addEventListener('DOMContentLoaded', demarre); } else { demarre(); }
})();
